/**
 * Equipment constants - browser-safe, zero imports.
 * This is the foundation file that other equipment files build upon.
 */
/**
 * Categories are translated at the application level using i18n keys, not in the database.
 * This avoids duplication across thousands of equipment records.
 */
const equipmentCategories = {
    /** Dumbbells, barbells, kettlebells, etc. */
    FREE_WEIGHTS: 'free_weights',
    /** Cable machines, smith machines, leg press, etc. */
    GYM_MACHINE: 'gym_machine',
    /** Pull up bar, parallel bars, gymnastic rings, dip bar, etc. */
    CALISTHENICS: 'calisthenics',
    /** Treadmill, elliptical, rower, bikes, etc. */
    CARDIO: 'cardio',
    /** Resistance bands, medicine ball, battle rope, etc. */
    FUNCTIONAL: 'functional',
    /** Foam rollers, massage balls, stretching aids */
    MOBILITY: 'mobility',
    /** Lifting straps, wrist wraps, gloves, belts, etc. */
    ACCESSORY: 'accessory',
    /** Miscellaneous equipment that doesn't fit into the other categories */
    OTHER: 'other',
};
/**
 * Defines the functional role of a piece of equipment within an exercise.
 * The 'role' dictates whether an equipment item provides the primary resistance
 * (and is thus trackable with metrics like weight), or is simply an accessory.
 */
const equipmentRoles = {
    /**
     * Equipment that provides the primary resistance for an exercise. Only 'load' equipment
     * is eligible to be paired with a movement to form a reusable 'exercise' record.
     * Examples: Dumbbell, Barbell, Kettlebell, a special 'Bodyweight' record.
     */
    LOAD: 'load',
    /** Any equipment that is not a 'load' equipment. */
    ACCESSORY: 'accessory',
};
export { equipmentCategories, equipmentRoles };
//# sourceMappingURL=equipment.constants.js.map